import "./index.css";
import React, { useEffect } from "react";
import { pure } from "recompose";
import { ToolbarComponent } from "@syncfusion/ej2-react-navigations";
import { useTranslation } from "react-i18next";
import DiagramBuilderIcon from "../../../../../assets/icons/DiagramBuilder";
import Calculator from "../../../../../assets/icons/Calculator";
// import { UploaderComponent } from "@syncfusion/ej2-react-inputs";
import {
    DiagramComponent,
    DiagramContextMenu,
    Inject,
    Node,
    PortConstraints,
    PortVisibility,
    SymbolPaletteComponent,
    UndoRedo,
} from "@syncfusion/ej2-react-diagrams";

let diagramInstance;
//Initializes the nodes for the diagram
let nodes = [
    {
        id: "Start",
        height: 50,
        width: 100,
        offsetX: 250,
        offsetY: 60,
        shape: { type: "Flow", shape: "Terminator" },
        annotations: [
            {
                content: "Start",
            },
        ],
        style: { fill: "#d0f0f1", strokeColor: "#797979" },
    },

    {
        id: "End",
        height: 50,
        width: 100,
        offsetX: 250,
        offsetY: 460,
        shape: { type: "Flow", shape: "Terminator" },
        annotations: [
            {
                content: "End",
            },
        ],
        style: { fill: "#d0f0f1", strokeColor: "#797979" },
    },
];

let interval = [
    1, 9, 0.25, 9.75, 0.25, 9.75, 0.25, 9.75, 0.25, 9.75, 0.25, 9.75, 0.25, 9.75,
    0.25, 9.75, 0.25, 9.75, 0.25, 9.75,
];
let gridlines = {
    lineColor: "#e0e0e0",
    lineIntervals: interval,
};
//Initializes the connector for the diagram
let connectors = [
    {
        id: "connector1",
        sourceID: "Start",
        targetID: "End",
    },
];
//Initialize the flowshapes for the symbol palatte

const SAMPLE_CSS = `
  .e-upload {
    display: none;
  }

  #palette-icon {
    display: none;
  }

  @media (max-width: 550px) {
      #palette-icon {
          display: inline-flex;
      }
  }
`;

let palettes = [
    {
        id: "flow",
        expanded: true,
        title: "Flow Shapes",
        symbols: [
            {
                id: "Terminator",
                addInfo: { tooltip: "Terminator" },
                width: 50,
                height: 60,
                shape: { type: "Flow", shape: "Terminator" },
                style: { strokeWidth: 1, strokeColor: "#757575" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
            },
            {
                id: "Process",
                addInfo: { tooltip: "Process" },
                width: 50,
                height: 60,
                shape: { type: "Flow", shape: "Process" },
                style: { strokeWidth: 1, strokeColor: "#757575" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
            },
            {
                id: "Decision",
                addInfo: { tooltip: "Decision" },
                width: 50,
                height: 50,
                shape: { type: "Flow", shape: "Decision" },
                style: { strokeWidth: 1, strokeColor: "#757575" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
            },
            {
                id: "Document",
                addInfo: { tooltip: "Document" },
                width: 50,
                height: 50,
                shape: { type: "Flow", shape: "Document" },
                style: { strokeWidth: 1, strokeColor: "#757575" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
            },
            {
                id: "PreDefinedProcess",
                addInfo: { tooltip: "Predefined process" },
                width: 50,
                height: 50,
                shape: { type: "Flow", shape: "PreDefinedProcess" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
                style: { strokeWidth: 1, strokeColor: "#757575" },
            },
            {
                id: "data",
                width: 50,
                height: 50,
                addInfo: { tooltip: "Data" },
                shape: { type: "Flow", shape: "Data" },
                ports: [
                    {
                        offset: { x: 0, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 0 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 1, y: 0.5 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                    {
                        offset: { x: 0.5, y: 1 },
                        visibility: PortVisibility.Connect | PortVisibility.Hover,
                        constraints: PortConstraints.Draw,
                    },
                ],
                style: { strokeWidth: 1, strokeColor: "#757575" },
            },
        ],
    },
    {
        id: "swimlaneShapes",
        expanded: true,
        title: "Swimlane Shapes",
        symbols: [
            {
                id: "stackCanvas1",
                addInfo: { tooltip: "Horizontal swimlane" },
                shape: {
                    type: "SwimLane",
                    lanes: [
                        {
                            id: "lane1",
                            style: { strokeColor: "#757575" },
                            height: 60,
                            width: 150,
                            header: {
                                width: 50,
                                height: 50,
                                style: { strokeColor: "#757575", fontSize: 11 },
                            },
                        },
                    ],
                    orientation: "Horizontal",
                    isLane: true,
                },
                height: 60,
                width: 140,
                offsetX: 70,
                offsetY: 30,
            },
            {
                id: "stackCanvas2",
                addInfo: { tooltip: "Vertical swimlane" },
                shape: {
                    type: "SwimLane",
                    lanes: [
                        {
                            id: "lane1",
                            style: { strokeColor: "#757575" },
                            height: 150,
                            width: 60,
                            header: {
                                width: 50,
                                height: 50,
                                style: { strokeColor: "#757575", fontSize: 11 },
                            },
                        },
                    ],
                    orientation: "Vertical",
                    isLane: true,
                },
                height: 140,
                width: 60,
                // style: { fill: '#f5f5f5' },
                offsetX: 70,
                offsetY: 30,
            },
            {
                id: "verticalPhase",
                addInfo: { tooltip: "Vertical phase" },
                shape: {
                    type: "SwimLane",
                    phases: [
                        {
                            style: {
                                strokeWidth: 1,
                                strokeDashArray: "3,3",
                                strokeColor: "#757575",
                            },
                        },
                    ],
                    annotations: [{ text: "" }],
                    orientation: "Vertical",
                    isPhase: true,
                },
                height: 60,
                width: 140,
                style: { strokeColor: "#757575" },
            },
            {
                id: "horizontalPhase",
                addInfo: { tooltip: "Horizontal phase" },
                shape: {
                    type: "SwimLane",
                    phases: [
                        {
                            style: {
                                strokeWidth: 1,
                                strokeDashArray: "3,3",
                                strokeColor: "#757575",
                            },
                        },
                    ],
                    annotations: [{ text: "" }],
                    orientation: "Horizontal",
                    isPhase: true,
                },
                height: 60,
                width: 140,
                style: { strokeColor: "#757575" },
            },
        ],
    },
    {
        id: "connectors",
        expanded: true,
        symbols: [
            {
                id: "Link1",
                type: "Orthogonal",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 40, y: 40 },
                targetDecorator: {
                    shape: "Arrow",
                    style: { strokeColor: "#757575", fill: "#757575" },
                },
                style: { strokeWidth: 1, strokeColor: "#757575" },
            },
            {
                id: "Link2",
                type: "Orthogonal",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 40, y: 40 },
                targetDecorator: {
                    shape: "Arrow",
                    style: { strokeColor: "#757575", fill: "#757575" },
                },
                style: {
                    strokeWidth: 1,
                    strokeDashArray: "4 4",
                    strokeColor: "#757575",
                },
            },
            {
                id: "Link21",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: {
                    shape: "Arrow",
                    style: { strokeColor: "#757575", fill: "#757575" },
                },
                style: { strokeWidth: 1, strokeColor: "#757575" },
            },
            {
                id: "Link22",
                type: "Straight",
                sourcePoint: { x: 0, y: 0 },
                targetPoint: { x: 60, y: 60 },
                targetDecorator: {
                    shape: "Arrow",
                    style: { strokeColor: "#757575", fill: "#757575" },
                },
                style: {
                    strokeWidth: 1,
                    strokeDashArray: "4 4",
                    strokeColor: "#757575",
                },
            },
        ],
        title: "Connectors",
    },
];


function DiagramBuilder({ setDiagramData, diagramData, setIsDiagramBuilder, setOpenRoi }) {
    const { t } = useTranslation();
    useEffect(() => {
        if (diagramData?.length > 0) diagramInstance.loadDiagram(diagramData);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function historyChanged() {
        setDiagramData(diagramInstance.saveDiagram())
    }

    const directFlowBuilder = () => {
        setIsDiagramBuilder(true);
        localStorage.setItem("tabs", "flow");
    }

    return (
        <div className="control-panel">
            <style>{SAMPLE_CSS}</style>
            <div className="control-section">
                <ToolbarComponent
                    id="toolbar_diagram"
                    style={{ width: "100%", height: "10%", marginTop: "10px" }}
                    clicked={(args) => {
                        if (args.item.text === "Clear") {
                            diagramInstance.clear();
                        } else if (args.item.text === "Load") {
                            document
                                .getElementsByClassName("e-file-select-wrap")[0]
                                .querySelector("button")
                                .click();
                        } else if (args.item.id === "palette-icon") {
                            openPalette();
                        } else {
                            // download(diagramInstance.saveDiagram());
                            localStorage.setItem("diagram", diagramInstance.saveDiagram());
                            setDiagramData(diagramInstance.saveDiagram());
                        }
                    }}
                    items={[
                        {
                            text: "Clear",
                            tooltipText: "Clear Screen",
                            prefixIcon: "",
                        },
                    ]}
                />
                <div>
                    <div id="palette-space" className="sb-mobile-palette">
                        <SymbolPaletteComponent
                            id="symbolpalette"
                            expandMode="Multiple"
                            palettes={palettes}
                            width={"100%"}
                            height={"560px"}
                            symbolHeight={48}
                            symbolWidth={48}
                            symbolMargin={{ left: 8, right: 8, top: 8, bottom: 8 }}
                            getSymbolInfo={(symbol) => {
                                return {
                                    tooltip: symbol.addInfo
                                        ? symbol.addInfo["tooltip"]
                                        : symbol.id,
                                };
                            }}
                        />
                    </div>

                    <div id="diagram-space" className="sb-mobile-diagram">

                        <DiagramComponent
                            id="diagram"
                            ref={(diagram) => (diagramInstance = diagram)}
                            width={"100%"}
                            height={"800px"}
                            nodes={nodes}
                            snapSettings={{
                                horizontalGridlines: gridlines,
                                verticalGridlines: gridlines,
                            }}
                            connectors={connectors}
                            getConnectorDefaults={(args) => {
                                args.targetDecorator.height = 5;
                                args.targetDecorator.width = 5;
                                args.style.strokeColor = "#797979";
                                args.targetDecorator.style = {
                                    fill: "#797979",
                                    strokeColor: "#797979",
                                };
                                return args;
                            }}
                            contextMenuSettings={{
                                show: true,
                            }}
                            historyChange={(args) => {
                                historyChanged();
                            }}
                            //Sets the Node style for DragEnter element.
                            dragEnter={(args) => {
                                let obj = args.element;
                                if (obj instanceof Node) {
                                    let ratio = 100 / obj.width;
                                    obj.width = 100;
                                    obj.height *= ratio;
                                }
                            }}
                        >
                            <div className="diagram-roi-buttons-container">
                                <button className="diagram-flow-button on-diagram-area" onClick={directFlowBuilder}>
                                    <DiagramBuilderIcon />
                                    <span>
                                        {t("CONTENT.DIAGRAM.FLOW")}
                                    </span>
                                </button>
                                <button className="diagram-flow-button roi-button-on-diagram-area"
                                    onClick={() => setOpenRoi(true)}>
                                    <Calculator />
                                    <span>{t("CONTENT.FLOW.ROI")}</span>
                                </button>
                            </div>
                            <Inject services={[UndoRedo, DiagramContextMenu]} />
                        </DiagramComponent>
                    </div>
                </div>
            </div>
        </div>
    );
}

// function onUploadSuccess(args) {
//   let file1 = args.file;
//   let file = file1.rawFile;
//   let reader = new FileReader();
//   reader.readAsText(file);
//   reader.onloadend = loadDiagram;
// }

//Load the diagraming object.
// function loadDiagram(event) {
//   diagramInstance.loadDiagram(event.target.result);
// }

//save the diagram object in json data.
// function download(data) {
//   if (window.navigator.msSaveBlob) {
//     let blob = new Blob([data], { type: 'data:text/json;charset=utf-8,' });
//     window.navigator.msSaveOrOpenBlob(blob, 'Diagram.json');
//   } else {
//     let dataStr = 'data:text/json;charset=utf-8,' + encodeURIComponent(data);
//     let a = document.createElement('a');
//     a.href = dataStr;
//     a.download = 'Diagram.json';
//     document.body.appendChild(a);
//     a.click();
//     a.remove();
//   }
// }

function openPalette() {
    let isMobile;
    let paletteSpace = document.getElementById("palette-space");
    isMobile = window.matchMedia("(max-width:550px)").matches;
    if (isMobile) {
        if (!paletteSpace.classList.contains("sb-mobile-palette-open")) {
            paletteSpace.classList.add("sb-mobile-palette-open");
        } else {
            paletteSpace.classList.remove("sb-mobile-palette-open");
        }
    }
}

export default DiagramBuilder;
